<template>
    <h5 :class="['ih7',cfg.class]">{{$t(cfg.label)}}</h5>
</template>
<script>
    export default {
        name:"ih7",
        //其中 width 规定线条的长度，还可以是百分比；color 表示颜色，size 表示厚度；
        props: {
            cfg: {
                type: Object,
                default: function () {
                    return {label:'',class:''}
                }
            }
        },
        
        data () {
            return {}
        },
        methods:{
            
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/ih7.vue